import { useNavigate } from "react-router-dom";

function PaymentPage({ prevStep, CreateAgent, isSubmitting, showSuccess }) {
  const navigate = useNavigate();

  return (
    <div className="payment-page-main">
      {/* =========================
          SUCCESS SCREEN
      ========================= */}

      {showSuccess ? (
        <div className="payment-success-wrapper">
          <div className="payment-success-card">
            {/* ICON */}

            <div className="success-icon">
              <img
                src={require("../../assests/images/payment_icon.png")}
                alt=""
                className="success-icon-img"
              />
            </div>

            {/* TITLE */}

            <h2>Successfully Joined Partner suite!</h2>

            {/* VALIDITY */}

            <p>
              Valid till:{" "}
              {new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </p>

            {/* BUTTON */}

            <button
              className="success-home-btn"
              onClick={() => navigate("/dashboard")}
            >
              Proceed to home
              <span>›</span>
            </button>
          </div>
        </div>
      ) : (
        <div className="payment-main-wrapper">
          {/* HEADER */}

          <div className="payment-top-header">
            <div className="payment-header-center">
              <h1>WedLuk Partner Suite</h1>

              <p>
                Complete your membership to access the full Matchmaking
                Management Suite.
              </p>

              <div className="payment-line"></div>
            </div>

            {/* PLAN CARD */}

            <div className="payment-plan-row">
              <div className="payment-plan-card">
                {/* TOP */}

                <div className="payment-plan-top">
                  {/* ICON */}

                  <div className="payment-icon orange">
                    <img
                      className="payment-icon-logo"
                      src={require("../../assests/images/payment_icon.png")}
                      alt=""
                    />
                  </div>

                  {/* CONTENT */}

                  <div className="payment-top-content">
                    <div className="payment-title">Partner Suite</div>

                    <div className="payment-price-row">
                      <h1>₹ 0/year</h1>

                      <span>Free</span>
                    </div>
                  </div>
                </div>

                {/* FEATURES */}

                <div className="payment-desc">
                  <ul>
                    <li>✓ End-to-end client management tools</li>

                    <li>✓ AI-assisted matchmaking support</li>

                    <li>✓ Verified profile access</li>

                    <li>✓ Match forwarding & tracking</li>

                    <li>✓ Faster workflow & organization</li>

                    <br />

                    <li>✓ Official agent listing on WedLuk</li>

                    <li>✓ Grow your client network digitally</li>
                  </ul>
                </div>

                {/* FOOTER */}

                <div className="payment-card-footer">
                  <div className="coupon-section">
                    <span>Coupon applied:</span>

                    <div className="coupon-box">EARLY-MEMBER ✕</div>
                  </div>

                  <button
                    className="payment-start-btn"
                    onClick={!isSubmitting ? CreateAgent : undefined}
                  >
                    {isSubmitting ? (
                      <div className="payment-loader"></div>
                    ) : (
                      <>Start Plan ›</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* BACK */}

          <div className="payment-back-row">
            <button onClick={prevStep} className="payment-back-btn">
              ‹ Back
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PaymentPage;
